import { render, staticRenderFns } from "./ModalAddActionItem.vue?vue&type=template&id=52a83a1a"
import script from "./ModalAddActionItem.vue?vue&type=script&lang=js"
export * from "./ModalAddActionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports